/**
 * @generated SignedSource<<34795dcaa82613cdd0b5d08b73629060>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommonQuery_getRscQuery$variables = {};
export type CommonQuery_getRscQuery$data = {
  readonly getRsc: ReadonlyArray<{
    readonly fileName: string;
    readonly url: string;
  }>;
};
export type CommonQuery_getRscQuery = {
  response: CommonQuery_getRscQuery$data;
  variables: CommonQuery_getRscQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GetFilesOutputObjectType",
    "kind": "LinkedField",
    "name": "getRsc",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommonQuery_getRscQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CommonQuery_getRscQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2f26424653bc76ec12e6b3c81a6f5360",
    "id": null,
    "metadata": {},
    "name": "CommonQuery_getRscQuery",
    "operationKind": "query",
    "text": "query CommonQuery_getRscQuery {\n  getRsc {\n    fileName\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d0ea1f1c62bbc2deba33add9011d4d3";

export default node;
